"use strict";

var _classCallCheck = require("/var/apps/finb/axis-frontend/axis-fe-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/var/apps/finb/axis-frontend/axis-fe-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/var/apps/finb/axis-frontend/axis-fe-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/var/apps/finb/axis-frontend/axis-fe-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/var/apps/finb/axis-frontend/axis-fe-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _Animations = require("../../contexts/Animations");

var _Animations2 = _interopRequireDefault(_Animations);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var AnimationsProvider =
/*#__PURE__*/
function (_react2$default$Compo) {
  _inherits(AnimationsProvider, _react2$default$Compo);

  function AnimationsProvider() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, AnimationsProvider);

    var _temp;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _possibleConstructorReturn(_this, (_temp = _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(AnimationsProvider)).call.apply(_getPrototypeOf2, [this].concat(args))), _this.elements = {}, _this.register = function (id, ref) {
      _this.elements[id] = ref;
    }, _this.unregister = function (id) {
      delete _this.elements[id];
    }, _this.play = function (id, options) {
      if (typeof _this.elements[id] !== "undefined") {
        _this.elements[id](options);
      }
    }, _temp));
  }

  _createClass(AnimationsProvider, [{
    key: "render",
    value: function render() {
      return _react2.default.createElement(_Animations2.default.Provider, _extends({
        value: {
          register: this.register,
          unregister: this.unregister,
          play: this.play
        }
      }, this.props));
    }
  }]);

  return AnimationsProvider;
}(_react2.default.Component);

exports.default = AnimationsProvider;